import { Options } from '@shared/ui/components/Select';

export type FrequentPassageRequestStatus = 'pending' | 'rejected' | 'approved' | 'redeemed';

export const frequentPassageRequestStatusOptions: Options<FrequentPassageRequestStatus> = [
  { value: 'pending', label: 'Pending' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'approved', label: 'Approved' },
  { value: 'redeemed', label: 'Redeemed' },
];
